// Tenant-specific routes
import React from 'react';
import TenantDashboard from '@/pages/inside/v1/tenant/Dashboard';
import Projects from '@/pages/inside/v1/tenant/Projects';
import ProjectDetail from '@/pages/inside/v1/tenant/ProjectDetail';
import Roles from '@/pages/inside/v1/tenant/Roles';
import Users from '@/pages/inside/v1/tenant/Users';
import Employees from '@/pages/inside/v1/modules/hr/employee/screen/Employee';
import Leave from '@/pages/inside/v1/modules/hr/leave/screen/Leave';
import Attendance from '@/pages/inside/v1/modules/hr/attendance/screen/Attendance';
import AttendanceDetail from '@/pages/inside/v1/modules/hr/attendance/screen/AttendanceDetail';
import Performance from '@/pages/inside/v1/modules/hr/performance/screen/Performance';
import RemovalRequests from '@/pages/inside/v1/tenant/RemovalRequests';
import OpenMarket from '@/pages/inside/v1/tenant/OpenMarket';
import OpenMarketProjectRequests from '@/pages/inside/v1/tenant/OpenMarketProjectRequests';
import Sales from '@/pages/inside/v1/tenant/Sales';
import Billing from '@/pages/inside/v1/tenant/Billing';
import Notifications from '@/pages/inside/v1/tenant/Notifications';
import Settings from '@/pages/inside/v1/tenant/Settings';
import Permissions from '@/pages/inside/v1/tenant/Permissions';
import Chat from '@/pages/inside/v1/tenant/Chat';
import Profile from '@/pages/inside/v1/tenant/Profile';
import Clients from '@/pages/inside/v1/tenant/Clients';
import AssetsManager from '@/pages/inside/v1/tenant/AssetsManager';
import ProjectTemplates from '@/pages/inside/v1/tenant/ProjectTemplates';
import Schedules from '@/pages/inside/v1/modules/hr/schedule/screen/Schedule';
import SalaryDistribution from '@/pages/inside/v1/modules/hr/salary/screen/SalaryDistribution';

const Placeholder = ({ label }) => <div style={{ padding: 24, textAlign: 'center' }}>{label}</div>;

export const tenantRoutes = [
    {
        path: '/dashboard',
        component: TenantDashboard,
        menuItem: { key: '/dashboard', label: 'Dashboard' },
    },
    {
        path: '/tenant/dashboard',
        component: TenantDashboard,
        menuItem: { key: '/tenant/dashboard', label: 'Dashboard' },
    },
    {
        path: '/projects',
        component: Projects,
        menuItem: { key: '/projects', label: 'Projects' },
        requiredPermission: null,
    },
    {
        path: '/tenant/projects',
        component: Projects,
        requiredPermission: null,
    },
    {
        path: '/projects/:projectId',
        component: ProjectDetail,
        requiredPermission: null,
    },
    {
        path: '/tenant/projects/:projectId',
        component: ProjectDetail,
        requiredPermission: null,
    },
    {
        path: '/clients',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/tenant/clients',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/clients/inhouse',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/tenant/clients/inhouse',
        component: Clients,
        requireAbility: ['clients.clients.view'],
    },
    {
        path: '/roles',
        component: Roles,
        menuItem: { key: '/roles', label: 'Overview' },
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/tenant/roles',
        component: Roles,
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/users',
        component: Users,
        menuItem: { key: '/users', label: 'Overview' },
        requiredPermission: 'saas.users.view',
    },
    {
        path: '/tenant/users',
        component: Users,
        requiredPermission: 'saas.users.view',
    },
    {
        path: '/hr/employees',
        component: Employees,
        menuItem: { key: '/hr/employees', label: 'Employees' },
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/tenant/hr/employees',
        component: Employees,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/hr/schedules',
        component: Schedules,
        menuItem: { key: '/hr/schedules', label: 'Schedules' },
        requiredPermission: 'hr.schedule.view',
    },
    {
        path: '/tenant/hr/schedules',
        component: Schedules,
        requiredPermission: 'hr.schedule.view',
    },
    {
        path: '/hr/leave',
        component: Leave,
        menuItem: { key: '/hr/leave', label: 'Leave' },
        requireAbility: ['hr.leave.view', 'hr.leaves.view'],
    },
    {
        path: '/tenant/hr/leave',
        component: Leave,
        requireAbility: ['hr.leave.view', 'hr.leaves.view'],
    },
    {
        path: '/hr/attendance',
        component: Attendance,
        menuItem: { key: '/hr/attendance', label: 'Attendance' },
        requiredPermission: 'hr.attendance.view',
    },
    {
        path: '/tenant/hr/attendance',
        component: Attendance,
        requiredPermission: 'hr.attendance.view',
    },
    {
        path: '/hr/attendance/detail',
        component: AttendanceDetail,
        requiredPermission: 'hr.attendance.view',
    },
    {
        path: '/tenant/hr/attendance/detail',
        component: AttendanceDetail,
        requiredPermission: 'hr.attendance.view',
    },
    {
        path: '/hr/performance',
        component: Performance,
        menuItem: { key: '/hr/performance', label: 'Performance' },
        requiredPermission: 'hr.performance.view',
    },
    {
        path: '/tenant/hr/performance',
        component: Performance,
        requiredPermission: 'hr.performance.view',
    },
    {
        path: '/hr/salary',
        component: SalaryDistribution,
        menuItem: { key: '/hr/salary', label: 'Salary' },
        requireAbility: ['hr.salary.view'],
    },
    {
        path: '/tenant/hr/salary',
        component: SalaryDistribution,
        requireAbility: ['hr.salary.view'],
    },
    {
        path: '/hr/removal-requests',
        component: RemovalRequests,
        menuItem: { key: '/hr/removal-requests', label: 'Removal Requests' },
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/tenant/hr/removal-requests',
        component: RemovalRequests,
        requiredPermission: 'hr.employees.view',
    },
    {
        path: '/open-market/overview',
        component: OpenMarket,
        menuItem: { key: '/open-market/overview', label: 'Overview' },
        requiredPermission: null,
    },
    {
        path: '/tenant/open-market/overview',
        component: OpenMarket,
        requiredPermission: null,
    },
    {
        path: '/open-market/project-requests',
        component: OpenMarketProjectRequests,
        requiredPermission: 'project_requests.requests.view',
    },
    {
        path: '/tenant/open-market/project-requests',
        component: OpenMarketProjectRequests,
        requiredPermission: 'project_requests.requests.view',
    },
    {
        path: '/sales/leads',
        component: Sales,
        menuItem: { key: '/sales/leads', label: 'Leads' },
        requiredPermission: 'sales.leads.view',
    },
    {
        path: '/tenant/sales/leads',
        component: Sales,
        requiredPermission: 'sales.leads.view',
    },
    {
        path: '/billing/requests',
        component: Billing,
        menuItem: { key: '/billing/requests', label: 'Requests' },
        requiredPermission: 'billing.requests.view',
    },
    {
        path: '/tenant/billing/requests',
        component: Billing,
        requiredPermission: 'billing.requests.view',
    },
    {
        path: '/notifications',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/tenant/notifications',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/notifications/unread',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/tenant/notifications/unread',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/notifications/read',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/tenant/notifications/read',
        component: Notifications,
        requiredPermission: null,
    },
    {
        path: '/permissions',
        component: Permissions,
        menuItem: { key: '/permissions', label: 'Permission Management' },
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/tenant/permissions',
        component: Permissions,
        requiredPermission: 'saas.roles.view',
    },
    {
        path: '/chat/:chatId',
        component: Chat,
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/tenant/chat/:chatId',
        component: Chat,
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/chat',
        component: Chat,
        menuItem: { key: '/chat', label: 'Chat' },
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/tenant/chat',
        component: Chat,
        requiredPermission: 'chat.chats.view',
    },
    {
        path: '/profile',
        component: Profile,
        menuItem: { key: '/profile', label: 'Profile' },
    },
    {
        path: '/tenant/profile',
        component: Profile,
    },
    {
        path: '/settings',
        component: Settings,
        menuItem: { key: '/settings', label: 'Settings' },
    },
    {
        path: '/tenant/settings',
        component: Settings,
    },
    {
        path: '/settings/origins',
        component: Settings,
    },
    {
        path: '/tenant/settings/origins',
        component: Settings,
    },
    {
        path: '/assets-manager',
        component: AssetsManager,
        requiredPermission: null,
    },
    {
        path: '/tenant/assets-manager',
        component: AssetsManager,
        requiredPermission: null,
    },
    {
        path: '/project-templates',
        component: ProjectTemplates,
        menuItem: { key: '/project-templates', label: 'Project Templates' },
        requiredPermission: null,
    },
    {
        path: '/tenant/project-templates',
        component: ProjectTemplates,
        requiredPermission: null,
    },
];
